export const accountRegisterMutation = (builder) => ({
  accountRegister: builder.mutation({
    query: (credentials) => {
      const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

      return {
        url: '/account_registration',
        method: 'POST',
        body: credentials,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token 
        },
      };
    },
  }),
});
